module.exports = __webpack_public_path__ + "static/gallery-5-db25899a72195d26bd777a1f8d9cb507.jpg";